import {Component, OnInit} from '@angular/core';
import {Subject} from 'rxjs';
import {Constants} from '../../constants';
import {DataManagementService} from '../../services/data-management.service';
import {AccessService} from '../../services/access.service';
import Swal from 'sweetalert2';
import {Router} from '@angular/router';

@Component({
    selector: 'app-pocs',
    templateUrl: './pocs.component.html',
    styleUrls: ['./pocs.component.css']
})
export class PocsComponent implements OnInit {
    dtTrigger: Subject<string> = new Subject();
    dtOptions: DataTables.Settings = {};
    data: object;
    errorMessage: string = undefined;
    pocs;

    constructor(private dmService: DataManagementService,
                private accessService: AccessService,
                private router: Router) {
    }

    getPOCs() {
        this.dmService.javaGetDataCall(Constants.INCOMING_POC)
            .subscribe(
                response => {
                    if (response.status === 'success') {
                        this.pocs = response.data;
                        if (this.pocs.length === 0) {
                            this.errorMessage = 'There is no data available for university POCs.';
                        } else {
                            this.dtTrigger.next();
                        }
                    } else if (response.status === 'fail') {
                        if (response.hasOwnProperty('message') && response.message !== '' &&
                            response.message !== null && response.message !== undefined) {
                            this.errorMessage = response.message;
                        } else {
                            this.errorMessage = 'Something went wrong. Please contact support team.';
                        }
                    }
                },
                error => {
                    console.log(error);
                    this.errorMessage = 'Server Error';
                    // this.errorMessage = error;
                });
    }

    sendEmailToPOC(poc): void {
        const that = this;
        let sendNominationResponse;
        const obj = {
            poc_id: poc.poc_id,
            incoming_term_id: poc.incoming_term_id,
            user_id: JSON.parse(localStorage.getItem('epas_user')).user_id
        };
        console.log(obj);
        Swal({
            title: 'Confirm',
            type: 'question',
            text: 'Do you want to send login details to ' + poc.poc_name + ' through email?',
            showCancelButton: true,
            confirmButtonClass: 'btn btn-outline-success rounded-0',
            cancelButtonClass: 'btn btn-outline-danger rounded-0',
            cancelButtonColor: '#d33',
            confirmButtonColor: '#5cb85c',
            cancelButtonText: 'No',
            confirmButtonText: 'Yes',
            showLoaderOnConfirm: true,
            preConfirm: function () {
                return new Promise(function (resolve, reject) {
                    that.dmService.javaPostDataCall(obj, Constants.LOGIN_DETAILS_TO_POC_BY_POC_ID).subscribe(resData => {
                        sendNominationResponse = resData;
                        resolve(sendNominationResponse);
                    }, error => {
                        sendNominationResponse = error;
                        reject(sendNominationResponse);
                    });
                });
            },
            allowOutsideClick: false,
        }).then(function (result) {
            if (result.hasOwnProperty('value')) {
                if (sendNominationResponse.status === 'success') {
                    Swal({
                        title: 'Success',
                        type: 'success',
                        showCancelButton: false,
                        showConfirmButton: true,
                        html: '<p>Successfully send login details to ' + poc.poc_name + '.</p>',
                    }).then(function (res) {
                        console.log(res);
                    }, function (timer) {
                        console.log(timer);
                    });
                } else if (sendNominationResponse.status === 'fail') {
                    if (sendNominationResponse.message !== 'null') {
                        Swal({
                            type: 'error',
                            title: 'Fail',
                            showCancelButton: false,
                            showConfirmButton: true,
                            html: '<p>Unable to send login details to ' + poc.poc_name + ', '
                                + sendNominationResponse.message + '</p>',
                        }).then(function (res) {
                            console.log(res);
                        }, function (timer) {
                            console.log(timer);
                        });
                    } else {
                        Swal({
                            type: 'error',
                            title: 'Fail',
                            showCancelButton: false,
                            showConfirmButton: true,
                            html: '<p>Unable to send login details to ' + poc.poc_name + ', Please contact support team.</p>',
                        }).then(function (res) {
                            console.log(res);
                        }, function (timer) {
                            console.log(timer);
                        });
                    }
                }
            }
        }, function (cancel) {
            console.log(cancel);
        }).catch(function (error) {
            console.log(error);
        });
    }

    canAccessOIA() {
        return this.accessService.canAccessOIA();
    }

    ngOnInit() {
        this.getPOCs();
        this.dtOptions = {
            paging: true,
            retrieve: true,
            destroy: true,
            lengthChange: true,
            info: false
        };
    }

}
